import Http from '@/classes/http/Http'

export default {
  getConfirmationForm: function (code) {
    return Http.get({
      url: `application/confirm/${code}`
    })
  },
  postConfirmationForm: function (code, formData) {
    return Http.post({
      url: `application/confirm/${code}`,
      data: formData
    })
  },
  getResetPasswordConfirmationForm: function (code) {
    return Http.get({
      url: `password-resets/${code}`
    })
  },
  postResetPasswordConfirmationForm: function (code, formData) {
    return Http.post({
      url: `password-resets/${code}`,
      data: formData
    })
  },
  getPostalCodeSuggestions: function (partialPostalCode) {
    return Http.get({
      url: `application/suggest-postal-code/${partialPostalCode}`
    })
  }
}
